import { CameraKit } from "./contexts/camera-kit-context";
import AppUI from "./app-ui";
import React, { useRef, useState } from "react";
import { SHOW_DEBUG } from "./constants";
import DebugScreen from "./components/debug-screen/debug-screen";
import Camera from "./libs/camera";
import DesktopPromo from "./desktop-promo";
import { useDeviceInfo } from "./hooks/useDeviceInfo";

const App = () => {
  const { isDesktop, orientation } = useDeviceInfo();
  const canvasRef = useRef(null);
  const [messages, setMessages] = useState(["Start"]);
  const [cameraFacing, onChangeCameraFacingHandler] = useState(Camera.BACK_CAMERA);

  const showDebug = (newMessages) => {
    setMessages((arr) => arr.concat(newMessages));
  };

  return (
    <div className="app-container">
      {isDesktop ? (
        <DesktopPromo />
      ) : (
        <>
          <canvas className={`ar-canvas ${cameraFacing} ${orientation}`} ref={canvasRef}></canvas>
          <CameraKit
            canvasRef={canvasRef}
            showDebug={showDebug}
            orientation={orientation}
            onChangeCameraFacing={onChangeCameraFacingHandler}
          >
            {orientation === "portrait" && <AppUI showDebug={showDebug} />}
          </CameraKit>
          {SHOW_DEBUG && <DebugScreen messages={messages} />}
          {orientation === "landscape" && (
            <div className="no-landscape-container">
              <div className="no-landscape-balenciaga"></div>
              <div className="no-landscape-image"></div>
              <div className="no-landscape-text">
                <span>rotate your smartphone</span>
                <span>to try on</span>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default App;
